import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'ggApp/shared/components/typography';
import { BlockHeading } from 'ggApp/shared/screens/PartnerProductPage/Common';
import { Wrapper } from './styled';

const AboutGrover = ({ content }) => {
    if (content?.mainTitle && content?.subText) {
        return (
            <Wrapper>
                <BlockHeading>{content.mainTitle}</BlockHeading>
                <Typography tag="p">{content.subText}</Typography>
            </Wrapper>
        );
    }
    return null;
};

AboutGrover.propTypes = {
    content: PropTypes.shape({
        mainTitle: PropTypes.string.isRequired,
        subText: PropTypes.string.isRequired,
    }).isRequired,
};

export default AboutGrover;
